export default "__VITE_ASSET__CnP54d6o__"